import { gql } from '@apollo/client';

export const EVENTO_FRAGMENT = gql`
  fragment EventoFragment on Evento {
    id
    folio
    descripcion
    tipoEvento
    nombre
    direccion {
      estado
      municipio
      calle
      numeroExterior
      colonia
      codigoPostal
      latitud
      longitud
    }
    lugar
    modalidad
    otroTipo
    usuariosIds
    zonaHoraria
    vinculo
    fechaFin
    fechaInicio
    horaInicio
    horaFin
    fechaHoraInicio
    fechaHoraFin
    listEventoDocumentos {
      id
    }
  }
`;

export const OBTENER_PAGINADO_EVENTOS = gql`
  query EventosPage(
    $query: QueryInput!
    $tipo: String
    $fechaInicio: Date
    $fechaFin: Date
    $modalidad: String
  ) {
    eventos {
      obtenerPaginado(
        query: $query
        tipo: $tipo
        fechaInicio: $fechaInicio
        fechaFin: $fechaFin
        modalidad: $modalidad
      ) {
        totalItems
        items {
          ...EventoFragment
          actividades {
            id
            tipoActividad
          }
        }
      }
    }
  }
  ${EVENTO_FRAGMENT}
`;

export const OBTENER_DOCUMENTOS_POR_EVENTO = gql`
  query ($id: ID!) {
    eventos {
      obtenerDocumentosPorEventoId(id: $id) {
        id
        fechaCreacion
        eventoId
        documento {
          key
          contentType
          nombreArchivo
          url
        }
      }
    }
  }
`;

export const OBTENER_ACTIVIDADES_POR_EVENTO = gql`
  query ($id: ID!) {
    eventos {
      obtenerActividadesPorEventoId(id: $id) {
        id
        activo
        fechaCreacion
        eventosIds
        tipoActividad
        asunto
        asignadosJSON
        cc
        cco
        descripcion
        eventosIds
        fechaHora
        fechaHoraFin
        hipervinculo
        invitadosIds
        esEvento
        para
        recordatorios
        tipoActividad
        tipoRegistro
        actividadDocumentos {
          id
          fechaCreacion
          actividadId
          documento {
            key
            contentType
            nombreArchivo
            url
          }
        }
      }
    }
  }
`;

export const OBTENER_TODOS_EVENTOS = gql`
  query TodosEventos {
    eventos {
      obtenerTodos {
        id
        nombre
      }
    }
  }
`;

export const OBTENER_EVENTOS_ACTIVOS = gql`
  query EventosActivos {
    eventos {
      obtenerEventosActivos {
        id
        nombre
      }
    }
  }
`;

export const OBTENER_EVENTO_POR_ID = gql`
  query ($id: ID!) {
    eventos {
      obtenerPorId(id: $id) {
        ...EventoFragment
        actividades {
          id
          tipoActividad
        }
      }
    }
  }
  ${EVENTO_FRAGMENT}
`;
